/**
 * Tickets/CompliancePins Controller
 *
 * 
 */

// the constructor for this object
function TicketsCompliancePinsController() { }

// the object
TicketsCompliancePinsController.prototype = {
    constructor: TicketsCompliancePinsController,
    
    // variables retrieved from the route
    ticketId: null,
    
    // initialize the controller
    init: function() 
    {
        // the user must be logged in to access this page
        PortalMain.authRedirect();
        
        PortalHelper.debugMessage('Tickets/CompliancePins Controller Initialized');
    },
    
    // run the controller
    run: function()
    {
        // register the events used by this controller
        this._registerEvents();
        
        // get the accounts with pins
        this._getAccountsWithPins();
        
        PortalHelper.debugMessage('Tickets/CompliancePins Controller Ran');
    },
    
    // register the javascript events
    _registerEvents:  function() 
    {    
        // send a pin reset email
        $('#accounts-table').on('click', '.reset-option .btn', function() {
            var accountId = $(this).closest('tr').attr('data-account-id');
            PortalMain.TicketsCompliancePinsController._sendPinReset(accountId);
        })
    },
    
    // get the accounts where the user has a pin
    _getAccountsWithPins: function() 
    {
        var getAccountsWithPinsRequest = new PortalRequest;
        getAccountsWithPinsRequest.makeRequest(
            '/pins/get-user-accounts-pins',
            {},
            function(data) {
                PortalMain.TicketsCompliancePinsController._populateAccountsWithPins(data);
                PortalHelper.loadingOverlay('#accounts-table', false);
            }
        );
    },
    
    // send a pin reset for the provided account
    _sendPinReset: function(accountId)
    {
        PortalHelper.loadingOverlay('tr[data-account-id=' + accountId + '] .reset-option', true);
        $('tr[data-account-id=' + accountId + '] .reset-option .btn').attr('disabled', true);
        
        var getAccountsWithPinsRequest = new PortalRequest;
        getAccountsWithPinsRequest.makeRequest(
            '/pins/send-pin-reset',
            {
                accountId: accountId
            },
            function(data) {
                PortalMain.TicketsCompliancePinsController._updateResetButton(data);
            }
        );
    },

    // populate the accounts with pins table
    _populateAccountsWithPins: function(pins)
    {
        // clear the old accounts
        $('#accounts-table tbody tr:not(.clone-source)').remove();

        var accounts = PortalMain.PortalAccounts.getAccounts();

        // add the accounts (that require compliance pins) to the table
        for (var i in accounts) {
            var account = accounts[i];
            if (account.require_pin) {
                
                var newEntry = $('#accounts-table tbody .clone-source').clone();
                newEntry.removeClass('clone-source');
            
                // set the account id
                $(newEntry).attr('data-account-id', account.account_id);
            
                // set the account name
                $('.account-name', newEntry).html(account.name);
                
                // set the account number
                $('.account-number', newEntry).html(account.account_number);
                
                // if the user does not have a pin say as much, otherwise allow the button
                var userHasPin = false;
                for (var a in pins) {
                    if (pins[a].account_id == account.account_id) {
                        userHasPin = true;
                    }
                }
                if (!userHasPin) {
                    $('.reset-option', newEntry).html('No&nbsp;PIN');
                }

                // add to to the table
                $('#accounts-table tbody').append(newEntry);
            }
        }        
    },

    // update the reset button
    _updateResetButton: function(data)
    {
        var accountId = data.account_id;
        
        PortalHelper.loadingOverlay('tr[data-account-id=' + accountId + '] .reset-option', false);
        $('tr[data-account-id=' + accountId + '] .reset-option .btn').html('Email&nbsp;Sent');
    },
    
}